export default {
  loadingLogList: false,
  cteLogList: [],
  cteLogListTotal: 0,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/cte-logs/store/states.js